import {
  TableCell,
  tableCellClasses,
  TableRow,
  TextField,
  styled,
} from "@mui/material";
import CheckAttr from "../../../utils/CheckAttr";
import { FC, useEffect, useState } from "react";
import { ArticleWithPrev, IPrevToSave } from "./IPrevisionnelQtArticle";
import useEnhancedEffect from "@mui/material/utils/useEnhancedEffect";
import { checkViaCodeArticle } from "../../../utils/utils";
import { codeArticleNotToDisable } from "../../../constants/Constants";
import { count } from "console";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    fontSize: 11,
    textAlign: "center",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 11,
    textAlign: "center",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

interface AddPrevQTRowFormProps {
  article: ArticleWithPrev;
  // tabRowsError: string[];
  // handleChangeRowsForBudget: (row: ROWTYPE, action: ActionType) => void;
  handeChangePrevisionnelTosave: (prevToFront: IPrevToSave) => void;
}

const AddprevisionnelQtRow: FC<AddPrevQTRowFormProps> = ({
  article,
  handeChangePrevisionnelTosave,
}) => {
  const [prevActeRow, setprevActeRow] = useState<Number>();
  const [prevHeureRow, setPrevHeureRow] = useState<Number>();
  const [prevRow, setPrevRow] = useState<IPrevToSave>();
  const [DisabledRow, setDisabeledRow] = useState<boolean>(false);

  const disableActeInput = (): boolean => {
    const tableArticle: string[] = [];

    tableArticle.push(article?.code_article.libelle);
    if (
      (CheckAttr(prevHeureRow) && prevHeureRow !== 0) ||
      checkViaCodeArticle(
        codeArticleNotToDisable,
        ["H", "h"],
        article?.code_article.libelle
      )
    ) {
      return true;
    }

    return false;
  };

  const disableHeureInput = (): boolean => {
    const tableArticle: string[] = [];
    tableArticle.push(article?.code_article.libelle);
    if (
      (CheckAttr(prevActeRow) && prevActeRow !== 0) ||
      checkViaCodeArticle(
        codeArticleNotToDisable,
        ["A", "a"],
        article?.code_article.libelle
      )
    ) {
      return true;
    }

    return false;
  };

  useEffect(() => {
    if (article?.previsionneleQT?.length !== 0) {
      setDisabeledRow(true);
    } else {
      setDisabeledRow(false);
    }
    if (article?.previsionneleQT.length > 0) {
      setprevActeRow(article?.previsionneleQT[0]?.acte_prev as Number || undefined);
      setPrevHeureRow(article?.previsionneleQT[0]?.heure_prev as Number || undefined);
    } else {
      console.log("Ato");
      setprevActeRow(undefined);
      setPrevHeureRow(undefined);
    }
  }, [article]);
  console.log(prevHeureRow);
  console.log(prevActeRow);
  return (
    <StyledTableRow>
      <StyledTableCell>{article?.code_article?.libelle}</StyledTableCell>
      <StyledTableCell align="center">{article?.libelle}</StyledTableCell>

      <StyledTableCell>
        <TextField
          name="Heure_Prev"
          color="warning"
          variant="filled"
          size="small"
          autoComplete="off"
          placeholder="Ex: 2.02"
          sx={{ width: 105 }}
          value={prevHeureRow === undefined ? "" : prevHeureRow}
          onChange={(e: any) => {
            setPrevHeureRow(e.target.value as Number);
            setPrevRow({
              ...prevRow,
              articleId: article?.id,
              heure_prev: e.target.value as number,
            });
            handeChangePrevisionnelTosave({
              ...prevRow,
              articleId: article?.id,
              heure_prev: e.target.value as number,
            });
          }}
          //error={tabRowsError?.includes(errorTxMarge)}
          /*InputLabelProps={{
            shrink: CheckAttr(article?.tx_marge_budget),
          }}*/
          inputProps={{
            step: 0.01,
            lang: "en-US",
          }}
          disabled={DisabledRow || disableHeureInput()}
        />
      </StyledTableCell>
      <StyledTableCell>
        <TextField
          name="Acte_prev"
          color="warning"
          variant="filled"
          size="small"
          autoComplete="off"
          placeholder="Ex: 2.02"
          sx={{ width: 105 }}
          value={prevActeRow  === undefined ? "" : prevActeRow }
          type="number"
          /* error={tabRowsError?.includes(errorCaBudget)}
          InputLabelProps={{
            shrink: CheckAttr(article?.ca_budget),
          }}*/
          onChange={(e: any) => {
            const valueToSaveFront = e.target.value;

            setprevActeRow(e.target.value as Number);
            setPrevRow({
              ...prevRow,
              articleId: article?.id,
              acte_prev: e.target.value as number,
            });
            handeChangePrevisionnelTosave({
              ...prevRow,
              articleId: article?.id,
              acte_prev: e.target.value as number,
            });
          }}
          disabled={DisabledRow || disableActeInput()}
          inputProps={{
            step: 0.01,
            lang: "en-US",
          }}
        />
      </StyledTableCell>
    </StyledTableRow>
  );
};

export default AddprevisionnelQtRow;
